import React, { useState } from "react";
import { DropdownData } from './DropdownData';
import './Accounts.css';
import { useSelector, useDispatch } from 'react-redux';
import styles from '../../views/ManagementPages.module.css';
import { setNestedField, setFormField } from './RegistrationSlice';
import { Form, FloatingLabel } from "react-bootstrap";
import Select from 'react-select';
import { customStyles } from "./CustomStyles";


const PersonalInfo = ({ errors, validated = false }) => {

    const dispatch = useDispatch();
    const userData = useSelector((state) => state.registration);
    const dropdowns = useSelector((state) => state.dropdowns);
    const role = userData.role.category;
    const userUnitType = userData.preferences.unitType.includes("Metric") ? "Metric" : userData.preferences.unitType.includes("Imperial") ? "Imperial" : "";
    const [unitType, setUnitType] = useState(userUnitType);
    const [phoneNumbersOnlyError, setPhoneNumbersOnlyError] = useState(false);
    const countryCodeErrorShowing = errors.countryCodeShowing && userData.countryCode === "";

    const [displayPhoneCountryCode, setDisplayPhoneCountryCode] = useState(() => {
        // If userData.countryCode contains a colon, it's in the old format
        const countryCode = userData.countryCode?.includes(':') 
            ? userData.countryCode.split(':')[0] 
            : userData.countryCode;
            
        const countryCodeMatch = dropdowns.countries.find((code) => code.phoneCountryCode === countryCode)
        if (countryCodeMatch && countryCode !== "") {
            return {
                value: countryCodeMatch.phoneCountryCode,
                label: `${countryCodeMatch.phoneCountryCode} (${countryCodeMatch.name})`
            }
        } else return {value:'', label: ''}
    });

    const [displayCountry, setDisplayCountry] = useState(() => {
        const selectedCountry = dropdowns.countries.find(country => country.code === userData.address.country);
        return selectedCountry ? { value: selectedCountry.code, label: selectedCountry.name } : { value: '', label: '' };
    });
    
    const [displayState, setDisplayState] = useState(() => {
        const selectedCountry = dropdowns.countries.find(country => country.code === userData.address.country);
        const selectedState = selectedCountry?.states.find(state => state.code === userData.address.state);
        return selectedState ? { value: selectedState.code, label: selectedState.name } : { value: '', label: '' };
    });

    const handleUnitChange = (e) => {
        setUnitType(e.target.value);
        dispatch(setNestedField({ parentKey: "preferences", nestedKey: e.target.id, value: e.target.value }))
    };

    const handlePhoneCountryCode = (selected) => {
        // Only store the phone country code part
        dispatch(setFormField({ key: "countryCode", value: selected ? selected.value : '' }));
        setDisplayPhoneCountryCode(selected || { value: '', label: '' });
    };

    const handleCountry = (selected) => {
        dispatch(setNestedField({ parentKey: "address", nestedKey: "country", value: selected.value }))
        dispatch(setNestedField({ parentKey: "address", nestedKey: "state", value: "" }))
        setDisplayState({ value: '', label: '' })
        setDisplayCountry(selected);
    };

    const handleState = (selected) => {
        dispatch(setNestedField({ parentKey: "address", nestedKey: "state", value: selected.value }))
        setDisplayState(selected);
    };

    return (
        <div className="create-account-inputs">
            <div className="input-name">
                Account Info
            </div>
            <Form.Group controlId="firstName">
                <FloatingLabel label="First Name*">
                    <Form.Control
                        value={userData.firstName}
                        className={`${styles.BorderedComponent}`}
                        onChange={(e) => dispatch(setFormField({ key: "firstName", value: e.target.value }))}
                        placeholder="First Name*"
                        style={{ width: "300px" }}
                        required
                        type="text"
                        isInvalid={validated && userData.firstName.trim() === ""}
                    />
                    <Form.Control.Feedback type="invalid">
                        Please provide your first name.
                    </Form.Control.Feedback>
                </FloatingLabel>
            </Form.Group>
            <Form.Group controlId="lastName">
                <FloatingLabel label="Last Name*">
                    <Form.Control
                        value={userData.lastName}
                        className={`${styles.BorderedComponent}`}
                        onChange={(e) => dispatch(setFormField({ key: "lastName", value: e.target.value }))}
                        placeholder="Last Name*"
                        style={{ width: "300px" }}
                        required
                        type="text"
                        isInvalid={validated && userData.lastName.trim() === ""}
                    />
                    <Form.Control.Feedback type="invalid">
                        Please provide your last name.
                    </Form.Control.Feedback>
                </FloatingLabel>

            </Form.Group>
            <Form.Group controlId="email">
                <FloatingLabel label="Email*">
                    <Form.Control
                        value={userData.email}
                        className={`${styles.BorderedComponent}`}
                        onChange={(e) => {
                            const trimmedValue = e.target.value.trim();
                            dispatch(setFormField({ key: "email", value: trimmedValue }));
                        }}
                        onBlur={(e) => {
                            const trimmedValue = e.target.value.trim();
                            dispatch(setFormField({ key: "email", value: trimmedValue }));
                        }}
                        placeholder="Email*"
                        style={{ width: "300px" }}
                        required
                        type="email"
                    />
                    <Form.Control.Feedback type="invalid">
                        Please provide a valid email address.
                    </Form.Control.Feedback>
                </FloatingLabel>
            </Form.Group>
            <div style={{ display: "flex", width: "300px", justifyContent: "space-between" }}>
                <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
                    <div style={{position: "relative", width: "125px"}}>
                        <span className={"floating-label"} style={{zIndex:"1"}}>Country Code*</span>
                        <Select
                            options={[...dropdowns.countries]
                                .sort((a, b) => {
                                    // If both countries have +1, sort by name
                                    if (a.phoneCountryCode === "+1" && b.phoneCountryCode === "+1") {
                                        // Prioritize United States specifically
                                        if (a.name === "United States") return -1;
                                        if (b.name === "United States") return 1;
                                        return a.name.localeCompare(b.name);
                                    }
                                    // Put +1 countries at the top
                                    if (a.phoneCountryCode === "+1") return -1;
                                    if (b.phoneCountryCode === "+1") return 1;
                                    // Then sort alphabetically by name
                                    return a.name.localeCompare(b.name);
                                })
                                .map((code) => ({
                                    label: `${code.phoneCountryCode} (${code.name})`,
                                    value: code.phoneCountryCode
                                }))}
                            styles={{
                                ...customStyles.popup,
                                container: (provided) => ({
                                    ...provided,
                                    width: '100%',
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected ? '#B2C7CE' : state.isFocused ? '#f0f0f0' : 'white',
                                    color: 'black',
                                    cursor: 'pointer',
                                    ':hover': {
                                        backgroundColor: state.isSelected ? '#B2C7CE' : '#f0f0f0',
                                    }
                                }),
                            }}
                            value={displayPhoneCountryCode}
                            placeholder='Code*'
                            isSearchable={true}
                            onChange={handlePhoneCountryCode}
                            defaultValue={null}
                            menuPlacement="auto"
                        />
                    </div>
                    {countryCodeErrorShowing &&
                        <div className="page-error">
                            Please provide a valid country code.
                        </div>
                    }
                </div>
                <Form.Group controlId="phonePersonal">
                    <FloatingLabel label="Phone Number*">
                        <Form.Control
                            required
                            value={userData.phone}
                            className={`${styles.BorderedComponent}`}
                            onChange={(e) => {
                                const raw = e.target.value;
                                const digitsOnly = raw.replace(/\D/g, "").slice(0, 10);
                                setPhoneNumbersOnlyError(/[^\d]/.test(raw));
                                dispatch(setFormField({ key: "phone", value: digitsOnly }));
                            }}
                            placeholder="Phone Number*"
                            style={{
                                width: "165px",
                                paddingRight: "0px"
                            }}
                            type="text"
                            inputMode="numeric"
                            autoComplete="tel-national"
                            pattern="[0-9]{10}"
                            isInvalid={
                                phoneNumbersOnlyError ||
                                (validated && !/^\d{10}$/.test(userData.phone))
                            }
                        />
                        <Form.Control.Feedback style={{ width: "170px" }} type="invalid">
                            {phoneNumbersOnlyError
                                ? "numbers only"
                                : "Please provide a valid phone number; phone numbers must be 10 digits in length."}
                        </Form.Control.Feedback>
                    </FloatingLabel>
                </Form.Group>
            </div>
            <div className="input-name">
                Address Info
            </div>
            <Form.Group controlId="AddressTypePersonal">
                <FloatingLabel label="Address Type">
                    <Form.Select
                        type="select"
                        value={userData.address.type}
                        className={`${styles.BorderedComponent}`}
                        onChange={(e) =>
                            dispatch(setNestedField({ parentKey: "address", nestedKey: "type", value: Number(e.target.value) }))
                        }
                        placeholder="Address Type"
                        style={{ width: "300px" }}
                    >
                        {/* <option value="">Address Type</option> */}
                        {dropdowns.addressType.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </Form.Select>
                </FloatingLabel>
            </Form.Group>
            <Form.Group controlId="address1Personal">
                <FloatingLabel label="Street Address (Ave, St, Blvd, etc.)">
                    <Form.Control
                        value={userData.address.address1}
                        className={`${styles.BorderedComponent}`}
                        onChange={(e) =>
                            dispatch(setNestedField({ parentKey: "address", nestedKey: "address1", value: e.target.value }))
                        }
                        placeholder="Street Address (Ave, St, Blvd, etc.)"
                        style={{ width: "300px" }}
                        type="text"
                    />
                </FloatingLabel>

            </Form.Group>
            <Form.Group controlId="address2Personal">
                <FloatingLabel label="Apartment, Suite, etc">
                    <Form.Control
                        value={userData.address.address2}
                        className={`${styles.BorderedComponent}`}
                        onChange={(e) =>
                            dispatch(setNestedField({ parentKey: "address", nestedKey: "address2", value: e.target.value }))
                        }
                        placeholder="Apartment, Suite, etc"
                        style={{ width: "300px" }}
                        type="text"
                    />
                </FloatingLabel>

            </Form.Group>
            <div style={{ display: "flex", flexDirection: "column", width: "300px" }}>
                <div className="input-block">
                    <div style={{position: "relative", width: "147px"}}>
                        <span className={"floating-label"} style={{zIndex:"1"}}>Country</span>
                            <Select
                                options={[...dropdowns.countries]
                                    .sort((a, b) => {
                                        // Prioritize United States
                                        if (a.name === "United States") return -1;
                                        if (b.name === "United States") return 1;
                                        // Then sort alphabetically by name
                                        return a.name.localeCompare(b.name);
                                    })
                                    .map((country) => ({
                                        label: country.name,
                                        value: country.code
                                    }))}
                                styles={{
                                    ...customStyles.popup,
                                    container: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                    }),
                                }}
                                value={displayCountry}
                                placeholder='Country'
                                isSearchable={true}
                                onChange={handleCountry}
                                defaultValue={null}
                                menuPlacement="auto"
                            />
                    </div>
                    <div style={{position: "relative", width: "147px"}}>
                        <span className={"floating-label"} style={{zIndex:"1"}}>State/Province</span>
                            <Select
                                options={
                                    displayCountry.value
                                        ? dropdowns.countries
                                              .find(country => country.code === displayCountry.value)
                                              ?.states.map(state => ({
                                                  label: state.name,
                                                  value: state.code
                                              })) || []
                                        : []
                                }
                                styles={{
                                    ...customStyles.popup,
                                    container: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                    }),
                                }}
                                value={displayState}
                                placeholder='State'
                                isSearchable={true}
                                onChange={handleState}
                            />
                    </div>
                </div>
                <div className="input-block" style={{ marginBottom: "0px" }}>
                    <Form.Group controlId="countryPersonal">
                        <FloatingLabel label="City">
                            <Form.Control
                                value={userData.address.city}
                                className={`${styles.BorderedComponent}`}
                                onChange={(e) =>
                                    dispatch(setNestedField({ parentKey: "address", nestedKey: "city", value: e.target.value }))
                                }
                                placeholder="City"
                                style={{ width: "147px" }}
                                type="text"
                            />
                        </FloatingLabel>
                    </Form.Group>
                    <Form.Group controlId="countryPersonal">
                        <FloatingLabel label="Postal Code">
                            <Form.Control
                                value={userData.address.zip}
                                className={`${styles.BorderedComponent}`}
                                onChange={(e) =>
                                    dispatch(setNestedField({ parentKey: "address", nestedKey: "zip", value: e.target.value }))
                                }
                                placeholder="Postal Code"
                                style={{ width: "147px" }}
                                type="text"
                                pattern="^\d{5}$"
                                isInvalid={
                                    validated &&
                                    !/^\d{5}$/.test(userData.address.zip)
                                }
                            />
                            <Form.Control.Feedback style={{ width: "147px" }} type="invalid">
                                Please provide a valid postal code; postal codes must contain only numbers and be 5 digits in length.
                            </Form.Control.Feedback>
                        </FloatingLabel>
                    </Form.Group>
                </div>
            </div>
            {role === "Patient" &&
                <div style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}>
                    <div className="input-name">
                        Preferences
                    </div>
                    <div style={{ position: "relative" }}>
                        <span className="floating-label">Date Format</span>
                        <select
                            className={styles["styled-input-select"]}
                            id="dateFormat"
                            value={userData.preferences.dateFormat}
                            onChange={(e) =>
                                dispatch(setNestedField({ parentKey: "preferences", nestedKey: "dateFormat", value: e.target.value }))
                            }
                            style={{ width: "300px" }}
                        >
                            <option value="">Select Date Format</option>
                            {DropdownData.dateFormats.map((type) => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="unit-types" style={{ display: "flex", width: "330px", justifyContent: "space-between", marginBottom: "20px" }}>
                        Unit Type
                        <div>
                            <input
                                id="unitType"
                                type="radio"
                                value="Imperial"
                                checked={unitType === 'Imperial'}
                                onChange={handleUnitChange}
                            />
                            <span style={{ paddingLeft: "5px" }}>Imperial (lb, F)</span>
                        </div>
                        <div>
                            <input
                                id="unitType"
                                type="radio"
                                value="Metric"
                                checked={unitType === 'Metric'}
                                onChange={handleUnitChange}
                            />
                            <span style={{ paddingLeft: "5px" }}>Metric (kg, C)</span>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default PersonalInfo;
